export const TEMPLATES = "Templates";
export const SCHOOLS = "Schools";
export const SPORTS = "Sports";
export const SEASONS = "Seasons";
export const VIDEO_UPLOAD="Video Upload"
export const OPEN_MENU = "Open Menu";
export const CLOSE_MENU = "Close Menu";
export const SIGN_OUT = "Sign Out";
export const CHANGE_PASS = "Change Password";
export const SUBSCRIPTION_PLAN='Subscription'
export const ENQUIRY_PLAN='Membership'



// WEBPACK FOOTER //
// ./src/features/admin/pages/AdminSidebar/constants.ts